// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"87806e04","728":"f416b5a3","928":"3430d7d3"}[chunkId] + ".chunk.js";
};